import { forceAppID } from "./force-id";
import { isPlayer } from "../routes";
import type { LocationSettings, Location, LocationSettingsWithURL } from "common/location-common";
import { getLocationSettingsUnsafe } from "common/location-common";
import { getFeatureFlag } from "common/feature-flags";
import type { AppKind } from "common/components/SerializedApp";

function getLocation(): Location {
    const { glideEnv } = window as any;
    if (forceAppID !== undefined || glideEnv === "prod" || getFeatureFlag("useProductionDatabase")) {
        return "production";
    }
    if (glideEnv === "staging") return "staging";
    if (glideEnv === "sandbox") return "sandbox";
    return "dev";
}

export function getLocationSettings(): LocationSettings;
export function getLocationSettings(appKind: AppKind): LocationSettingsWithURL;
export function getLocationSettings(appKind?: AppKind): LocationSettings {
    const location = getLocation();
    const player = isPlayer();
    let settings = getLocationSettingsUnsafe(location, player, appKind);

    if ((window as any).overrideCloudFunctionLocation !== undefined) {
        settings = {
            ...settings,
            cloudURLPrefix: (window as any).overrideCloudFunctionLocation,
        };
    }

    if (location === "dev" && window.location.hostname !== "localhost") {
        // If we're on a development platform but aren't exactly on "localhost",
        // we need to redirect through staging proper to make Sign in with Google
        // function correctly.
        const stagingSettings = getLocationSettingsUnsafe("staging", player, appKind);
        settings = {
            ...settings,
            oAuthCallbackURL: stagingSettings.oAuthCallbackURL,
        };
    }

    return settings;
}
